import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import DatePicker from 'react-datepicker';
import { AsyncPaginate } from 'react-select-async-paginate';
import { Button } from 'react-bootstrap';
import { URL } from '../../../../redux/common/url';
import moment from 'moment';

function VehicleForm({ onSubmit,jenId,vehicleKey }: any) {
  const [vehicle, setVehicle] = useState<any>(null); // Store full vehicle object
  const [fromDate, setFromDate] = useState<any>(null);
  const [toDate, setToDate] = useState<any>(null);
  const vehicles = useSelector((state: any) => state.admin.vehicle_list?.data || []);

  useEffect(() => {
    setVehicle(null);
  },  [jenId]);

  const loadOptions = async (search: any, loadedOptions: any, { page }: any) => {
    if (!jenId) {
      return { options: [], hasMore: false };
    }
    try {
      const tokenStr = localStorage.getItem('kt-auth-react-v');
      const apiToken = tokenStr ? JSON.parse(tokenStr).api_token : '';
      const searchString = search ? search.toString() : '';
      const response = await fetch(
        `${URL.API_BASE_URL}/api/admins/all_vehicles?` +
        `jen_id=${jenId}&search=${searchString}&page=${page}`,
        {
          headers: { Authorization: `Bearer ${apiToken}` },
        }
      );
      const result = await response.json();
      if (!result.status) {
        return { options: [], hasMore: false, additional: { page: page + 1 } };
      }
      const res = result.data;
      const options = res.data.map((v: any) => ({
        ...v,
        value: v.id,
        label: v.registration_number,
      }));
      return { options, hasMore: res.total > (res.per_page * page), additional: { page: page + 1 } };
    } catch (error) {
      console.error('Fetch Error:', error);
      return { options: [], hasMore: false, additional: { page: page + 1 } };
    }
  };

 const handleSubmit = (e: any) => {
  e.preventDefault();

  if (vehicle) {
    onSubmit({
      vehicle,
      fromdate: fromDate
        ? moment(fromDate).format('YYYY-MM-DD')
        : '',
      todate: toDate
        ? moment(toDate).format('YYYY-MM-DD')
        : '',
    });
  }
};

  return (
    <form onSubmit={handleSubmit} className="p-5">
      <div className="row mb-3">
        <div className="col-md-4">
          <label className="form-label">Select Vehicle</label>
          <AsyncPaginate
            key={vehicleKey}
            value={vehicle}
            loadOptions={loadOptions}
            onChange={(e: any) => setVehicle(e)}
            additional={{ page: 1 }}
            isDisabled={!jenId}
            placeholder={jenId ? 'Select Vehicle' : 'Select vehicle'}
          />

        </div>
        <div className="col-md-4">
          <label className="form-label">From Date (Optional)</label>
          <DatePicker
            selected={fromDate}
            onChange={(date: any) => setFromDate(date)}
            className="form-control"
            dateFormat="yyyy-MM-dd"
            placeholderText="Select From Date"
          />
        </div>
        <div className="col-md-4">
          <label className="form-label">To Date (Optional)</label>
          <DatePicker
            selected={toDate}
            onChange={(date: any) => setToDate(date)}
            className="form-control"
            dateFormat="yyyy-MM-dd"
            placeholderText="Select To Date"
          />
        </div>
      </div>
      <Button type="submit" variant="primary">Submit</Button>
    </form>
  );
}

export default VehicleForm;